import { Component, Input } from '@angular/core';
import { ModalService } from '@fcp/lib-ui';
import { CMSContentService } from '../../../essentials/cms/content/cms-content.service';

@Component({
  selector: 'fcp-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.scss']
})
export class HelpdeskComponent {
  @Input() data: any;

  constructor(
    private modalService: ModalService,
    private cmsContentService: CMSContentService,
  ) { }

  openModal(item) {
    if (item.button.toLowerCase() === 'rede credenciada') {
      this.modalService.open({
        tabs: null,
        buttons: null,
        data: null,
        img: '',
        title: '',
        titleTabs: null,
        subtitleTabs: null,
        type: 'Rede Credenciada',
        text: null
      });
    } else if (item.modal) {
      this.cmsContentService.openModal(item.modal);
    }
  }

}
